import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../api";
import { useSeo } from "../seo";
import { useContent } from "../content";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function CustomPage() {
  const { slug } = useParams();
  const { owner } = useContent();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    setPage(null);
    setMissing(false);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setMissing(true));
  }, [slug]);
  useSeo({ title: page?.title, path: `/p/${slug}`, noindex: true });
  if (missing) {
    return (
      <div data-testid="custom-page-missing" className="px-6 pt-16 text-center">
        <h1 className="font-display text-3xl font-bold">Page not found</h1>
        <Link to="/experience" className="inline-block mt-4 text-[#D4AF37] text-sm font-bold tracking-widest">BACK HOME</Link>
      </div>
    );
  }
  if (!page) return <div className="px-6 pt-16 text-center text-white/40 text-sm">Loading…</div>;
  return (
    <div data-testid={`custom-page-${slug}`} className="px-5 pt-8 pb-12 mx-auto w-full max-w-3xl">
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">{page.title}</h1>
      {owner && (
        <Link to="/experience/admin" data-testid="custom-page-edit-link"
          className="inline-block mt-3 text-[10px] font-bold tracking-widest text-[#D4AF37] border border-[#D4AF37]/50 rounded-full px-4 py-2">
          EDIT THIS PAGE — ADMIN → SITE
        </Link>
      )}
      <div className="mt-6 space-y-5">
        {(page.sections || []).map((s, i) => {
          if (s.type === "heading") return <h2 key={i} className="font-display text-lg md:text-lg font-semibold mt-2">{s.text}</h2>;
          if (s.type === "image") {
            const src = s.url.startsWith("/") ? `${BACKEND_URL}${s.url}` : s.url;
            return <img key={i} src={src} alt={page.title} className="w-full rounded-2xl border border-white/10" />;
          }
          return <p key={i} className="text-base text-white/75 leading-relaxed whitespace-pre-wrap">{s.text}</p>;
        })}
      </div>
    </div>
  );
}
